import { Container } from 'react-bootstrap';

import type { ChildrenProps, ClassNameProps } from '@/types/common.types';

import { PlayerContextProvider } from '@/views/MovieDetailsView/MoviePlayerContext';
import { RelatedMoviesView } from '@/views/MovieDetailsView/RelatedMoviesView';

export const MovieDetailsLayout = (
  props: ChildrenProps & ClassNameProps & { movieTitle: string },
) => {
  const { children, className, movieTitle } = props;

  return (
    <PlayerContextProvider movieTitle={movieTitle}>
      <Container className={className}>{children}</Container>
      <RelatedMoviesView />
    </PlayerContextProvider>
  );
};
